import * as React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalSurveyTemplate } from "../../amorg-common";
import { getActiveUser, getGlobalSurveyTemplates } from '../../api/adminClientApi';
import { ButtonRow } from '../../designSystem/button/ButtonRow';
import { LinkButton } from '../../designSystem/button/LinkButton';
import { Flex } from '../../designSystem/compositeComponents/FlexHelpers';
import { Divider } from '../../designSystem/Divider';
import { LoadingPageOverlay } from '../../designSystem/LoadingPageOverlay';
import { H1, H2 } from '../../designSystem/typography/Heading';
import { SurveyTemplateList } from './_components/SurveyTemplateList';
import { AmorgyPageWrapper } from '../_pageWrappers/AmorgyPageWrapper';
import { SingleColumnLayout } from '../_layouts/SingleColumnLayout';

export default function AmorgAdminGlobalTemplates (): JSX.Element 
{
    const navigate = useNavigate();

    const [loading, setLoading] = React.useState(true);
    const [globalTemplates, setGlobalTemplates] = React.useState<GlobalSurveyTemplate[]>([]);

    useEffect(() =>
    {
        document.title = 'Amorgy - Globale skabeloner';
        const init = async () =>
        {
            await getActiveUser(() => navigate(`/amorgy/login`));
            setGlobalTemplates(await getGlobalSurveyTemplates(() => navigate(`/amorgy/login`)));
            setLoading(false);
        };
        init().catch(console.error);
    }, []);

    const active = globalTemplates.filter(t => t.enabled);
    const inactive = globalTemplates.filter(t => !t.enabled);

    return (
        <AmorgyPageWrapper selectedTab={'overview'}>
            <SingleColumnLayout narrow>

            <LoadingPageOverlay loading={loading} />

            <ButtonRow variant='right-aligned'>
                <LinkButton variant="filled" icon="interface_actions_download" href={'/amorgy/importtemplate'} text='Importér skabelon' />
            </ButtonRow>

                <Flex flexDirection="column" gap={16}>
                    <H1>Globale skabeloner</H1>

                    <H2>Aktive skabeloner</H2>
                    <SurveyTemplateList
                        templates={active}
                        buttons={[
                            {
                                variant: 'filled',
                                text: 'redigér',
                                onClick: (templateId) => navigate(`/amorgy/edittemplate/${templateId}`)
                            }
                        ]} />

                    <div style={{ marginTop: '30px', marginBottom: '10px' }}>
                        <Divider />
                    </div>

                    <H2>Inaktive skabeloner {active.length}</H2>
                    <SurveyTemplateList
                        templates={inactive}
                        buttons={[
                            {
                                variant: 'filled',
                                text: 'redigér',
                                onClick: (templateId) => navigate(`/amorgy/edittemplate/${templateId}`)
                            }
                        ]}
                    />
                </Flex>
            </SingleColumnLayout>
        </AmorgyPageWrapper>
    );
}

